import { Pagination, Swiper, EffectFade } from 'swiper';

class HomeSwiper {
  constructor(element) {
    if (!(element instanceof HTMLElement)) {
      throw new TypeError('Invalid element');
    }

    this.element = element;
    this.extras = this.element.querySelector('.swiper-extras');
    this.pagiantion = this.extras.querySelector('.swiper-pagination');

    this.initSwiper();
    this.initEvents();
  }

  initSwiper() {
    this.swiper = new Swiper(this.element, {
      modules: [Pagination, EffectFade],
      // allowTouchMove: false,
      slidesPerView: 1,
      spaceBetween: 0,
      effect: 'fade',
      loop: true,
      pagination: {
        el: this.pagiantion,
        clickable: true,
      },
      on: {
        init: this.fixPadding.bind(this),
        transitionStart: this.stopVideo,
        transitionEnd: this.startVideo,
      },
    });
  }

  initEvents() {
    window.addEventListener('resize', () => {
      this.fixPadding(this.swiper);
    });
  }

  fixPadding(swiper) {
    setTimeout(() => {
      const height = this.extras.offsetHeight;

      swiper.slides.forEach((slide) => {
        const el = slide.querySelector('.slide');

        el.style.paddingBottom = `${height}px`;
        el.classList.add('initialised');
      });
    }, 100);
  }

  startVideo = (swiper) => {
    const slide = swiper.slides[swiper.activeIndex];
    const video = slide.querySelector('video');

    if (video) {
      video.play();
    }
  };

  stopVideo = (swiper) => {
    const slide = swiper.slides[swiper.activeIndex];
    const video = slide.querySelector('video');

    if (video) {
      video.pause();
      video.currentTime = 0;
    }
  };
}

export default HomeSwiper;
